import { type TranslationTree } from '@/i18n/types';

export const messages = {
  error: 'Não foi possível entrar, verifique email e senha',
} satisfies TranslationTree;
